
import { computed, defineComponent, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { validatePrivateKey, createFromPrivateKey } from '@/services/account'
export default defineComponent({
  name: 'Import wallet',
  setup() {
    const store = useStore()
    const router = useRouter()

    const name = ref('')
    const source = ref('')
    const isValidSource = computed(() => {
      return validatePrivateKey(source.value)
    })

    const importedWallet = computed(() => {
      return createFromPrivateKey(source.value)
    })

    function importWallet() {
      if (isValidSource.value) {
        createFromPrivateKey(source.value)
        store.dispatch('wallets/storeWallet', {
          name: name.value,
          address: importedWallet.value.address,
          privateKey: importedWallet.value.privateKey
        })
        store.commit('auth/setAuth', true)

        router.push('/swap')
      }
    }

    return {
      name,
      source,
      isValidSource,
      importWallet
    }
  }
})
